"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgPlus = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M5 11h6V5c-.011-.667.322-1 1-1 .678 0 1.011.333 1 1v6h6c.667 0 1 .333 1 1s-.333 1-1 1h-6v6c.015.667-.318 1-1 1-.682 0-1.015-.333-1-1v-6H5c-.667 0-1-.332-1-1 0-.668.333-1 1-1z' }))); };
exports.default = SvgPlus;
//# sourceMappingURL=Plus.js.map